import React from 'react';

/**
 * UAE Dirham Symbol Component
 * Based on the official symbol unveiled by UAE Central Bank in March 2025
 * A stylized "D" with two horizontal lines inspired by the UAE flag
 * 
 * Uses currentColor to inherit text color automatically
 */

export const DirhamIcon = ({ className = "", size = "1em" }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 20 20" 
    fill="currentColor"
    className={`inline align-middle ${className}`}
    style={{ 
      verticalAlign: 'middle',
      marginRight: '0.15em',
      marginTop: '-0.1em'
    }}
  >
    {/* Stylized D */}
    <path d="M3 2h6c3.866 0 7 3.134 7 7s-3.134 7-7 7H3V2zm2.5 2.5v9H9c2.485 0 4.5-2.015 4.5-4.5S11.485 4.5 9 4.5H5.5z" />
    {/* Two parallel lines */}
    <rect x="1" y="7.5" width="18" height="1.2" rx="0.6" />
    <rect x="1" y="11.3" width="18" height="1.2" rx="0.6" />
  </svg>
);

/**
 * Currency Display Component with Dirham symbol
 * Symbol inherits text color automatically via currentColor
 */
export const CurrencyDisplay = ({ 
  amount, 
  size = "1em", 
  className = "", 
  showDecimals = false
}) => {
  const formattedAmount = showDecimals 
    ? (amount || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    : Math.round(amount || 0).toLocaleString();
  
  return (
    <span 
      className={`inline-flex items-center whitespace-nowrap ${className}`}
      style={{ fontVariantNumeric: 'tabular-nums' }}
    >
      <DirhamIcon size={size} />
      {formattedAmount}
    </span>
  );
};

/**
 * Helper function to format number without symbol
 */
export const formatAmount = (amount, showDecimals = false) => {
  if (amount === null || amount === undefined) return '0';
  return showDecimals 
    ? amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    : Math.round(amount).toLocaleString();
};

export default DirhamIcon;
